// Anglar
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

// Services
import { CoreService } from './shared/services/core.service';
import { BrowserService } from './shared/services/browser.service';
import { WINDOW_PROVIDER, LOCAL_STORAGE_PROVIDER } from './shared/tokens';

@NgModule({
	imports: [CommonModule, HttpClientModule],
	declarations: [],
	exports: [HttpClientModule],
	providers: [CoreService, BrowserService, LOCAL_STORAGE_PROVIDER, WINDOW_PROVIDER],
})
export class CoreModule {}
